import axiosConfig from "./axiosConfig";

export interface LeadResearchCostTotals {
  runCount: number;
  testRunCount: number;
  modelUsd: number;
  webSearchUsd: number;
  totalUsd: number;
  webSearchCount: number;
  // Apollo enrichment credits (a non-USD budget), so a contacts-enrichment run
  // shows a real credit count rather than a $0 row.
  apolloCredits: number;
  // Apollo discovery calls (free but call-capped), so a people-discovery run shows a
  // real call count rather than looking like a $0 no-op.
  apolloSearchCalls: number;
}

export interface LeadResearchCostRun {
  id: string;
  createdAt: string;
  // Which lead-pipeline surface the spend came from (the AI-invocation ledger
  // `source` label, e.g. landlord-research vs people-discovery). The card routes
  // the trace link by this.
  source: string | null;
  // The trace subject ref (prompt-test:<ref> for a test run, the raw ref for a
  // live run) - also the first half of the trace lookup key.
  subjectRef: string | null;
  isTest: boolean;
  failed: boolean;
  webSearchCount: number;
  // Apollo enrichment credits used by this run; null for non-enrichment rows.
  apolloCredits: number | null;
  // Apollo discovery calls made by this run; null for non-discovery rows.
  apolloSearchCalls: number | null;
  modelUsd: number;
  webSearchUsd: number;
  totalUsd: number;
  traceSubjectRef: string | null;
  traceRunId: string | null;
}

export interface LeadResearchCostSourceTotals {
  runCount: number;
  totalUsd: number;
  apolloCredits: number;
  apolloSearchCalls: number;
}

export interface LeadResearchCostsResponse {
  windowDays: number;
  generatedAt: string;
  // Costs are ESTIMATES computed from per-model token + web-search counts on read.
  webSearchUsdPerQuery: number;
  totals: LeadResearchCostTotals;
  // Spend split by lead-pipeline surface (source label -> run count + $), so the
  // card can show landlord-research vs people-discovery separately.
  bySource: Record<string, LeadResearchCostSourceTotals>;
  recent: LeadResearchCostRun[];
  truncated: boolean;
}

const getLeadResearchCosts = async (
  authToken: string,
  days: number
): Promise<LeadResearchCostsResponse> => {
  const { data } = await axiosConfig.get(`/leads/research-costs`, {
    params: { days },
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default getLeadResearchCosts;
